import {isNil, orderBy} from 'lodash';
import {NxSelectOption} from '@nextbank/ui-components';
import {Category} from '../shared/model/category.model';
import {Dictionary} from '../shared/model/dictionary.model';
import {addParentsToCategoryName} from './category-utils';
import {DictionaryHelper} from './dictionary-helper';

interface Entry {
  id: number;
  name: string;
  enabled?: boolean;
}

const mapToStringOptions = (entries: Entry[] = []): NxSelectOption[] =>
  mapToNumberOptions(entries).map(option => ({...option, value: String(option.value)}));

const mapToNumberOptions = (entries: Entry[] = []): NxSelectOption<number>[] =>
  entries
    .sort(((entryA, entryB) => (entryA.name < entryB.name ? -1 : 1)))
    .map(entry => ({ value: entry.id, label: entry.name, disabled: !isNil(entry.enabled) && !entry.enabled }));

export const SelectHelper = {

  mapToStringOptions,

  mapToNumberOptions,

  mapDictionaryToOptions: (dictionaries?: Dictionary[], dictionaryId?: number): NxSelectOption[] | undefined  => {
    if (!dictionaries || !dictionaryId) {
      return;
    }

    const entries = DictionaryHelper.getEntries(dictionaries, dictionaryId);

    return mapToStringOptions(entries);
  },

  mapCategoriesToOptions: (categories: Category[]): NxSelectOption<number>[] => {

    const categoriesWithParentNames = addParentsToCategoryName(categories);

    // TODO sort categories on FE by orderNo not names
    return mapToNumberOptions(orderBy(categoriesWithParentNames, ['name']));
  }
};

